// --------------------------------------------------------------
// Created On: 2025-08-05
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./WarningList.module.scss";

// List of warning messages in one container.
export default function WarningList(props: Props): Component {
  return props.mainMessage.length > 0 ? (
    <div className={`${styles.body} alert alert-warning`} role="alert">
      {props.mainMessage}
      {props.messages.length > 0 && (
        <ul className="mb-1">
          {props.messages.map((message) => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      )}
    </div>
  ) : null;
}

interface Props {
  mainMessage: string;
  messages: string[];
}
